import { render, staticRenderFns } from "./BaseBadge.vue?vue&type=template&id=7fda04c0&"
import script from "./BaseBadge.vue?vue&type=script&lang=ts&"
export * from "./BaseBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports